// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__9WGZK","right":"styles_right__1MZUL"};